import { useEffect, useState } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useParams } from "react-router-dom";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import { config, priceFormat, shortenUrl } from "./Components/Config";
import { format } from "date-fns";
import { Modal } from "react-bootstrap";

const QuotationApproval = () => {
  const { id_quotation } = useParams();
  const [ quotation, setQuotation ] = useState(null);
  const [ paymentSimulations, setPaymentSimulations ] = useState(null);
  const [ approvalStatus, setApprovalStatus ] = useState(null);
  const [ approvalRemarks, setApprovalRemarks ] = useState(null);
  const [ showApproval, setShowApproval ] = useState(false);
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  const getQuotation = async () => {
    try {
      const fetchQuotation = await jwtFetch(config.ENDPOINT + 'get/quotation', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_quotation: id_quotation
        })
      });
      const responseQuotation = await fetchQuotation.json();
      if (responseQuotation.status === 200) {
        setQuotation(responseQuotation.data[0]);
      } else {
        alert(responseQuotation.message);
      }
    } catch (error) {
      console.error('Error in getQuotation:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getPaymentSimulations = async () => {
    try {
      const fetchPaymentSimulations = await jwtFetch(config.ENDPOINT + 'get/quotation_payment_simulation', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          quotation_id: id_quotation
        })
      });
      const responsePaymentSimulations = await fetchPaymentSimulations.json();
      if (responsePaymentSimulations.status === 200) {
        setPaymentSimulations(responsePaymentSimulations.data);
      } else {
        alert(responsePaymentSimulations.message);
      }
    } catch (error) {
      console.error('Error in getPaymentSimulations:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };
  
  const editStatus = async () => {
    try {
      setIsLoadingSubmit(true);
      const crmUser = JSON.parse(localStorage.getItem('crmUser'));
      const requestEditQuotation = {
        id_quotation: id_quotation,
        quotation_status: 'Open',
        quotation_approval: approvalStatus,
        updated_by: crmUser.user_keyid,
        updated_on: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      }
      if (quotation.quotation_approval === 'Pending Approval') {
        requestEditQuotation.approval_1_remarks = approvalRemarks;
      } else if (quotation.quotation_approval === 'Pending Approval 1') {
        requestEditQuotation.quotation_approval = approvalStatus === 'Approved' ? 'Pending Approval 2' : 'Rejected';
        requestEditQuotation.approval_1_remarks = approvalRemarks;
      } else if (quotation.quotation_approval === 'Pending Approval 2') {
        requestEditQuotation.approval_2_remarks = approvalRemarks;
      }
      const fetchEditQuotation = await jwtFetch(config.ENDPOINT + 'update/quotation', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestEditQuotation)
      });
      const responseEditQuotation = await fetchEditQuotation.json();
      if (responseEditQuotation.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error in editStatus:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  };

  useEffect(() => {
    if (id_quotation) {
      getQuotation();
      getPaymentSimulations();
    }
  }, [id_quotation]);
  
  useEffect(() => {
    if (approvalStatus === 'Rejected') {
      setApprovalRemarks('');
      setShowApproval(true);
    } else if (approvalStatus === 'Approved') {
      editStatus();
    }
  }, [approvalStatus]);

  return (
    <div id="quotation-approval">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="quotation"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="p-4">

              {quotation && (
                <div className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center">
                      <div className="fs-24">Quotation Approval</div>
                      <span className={"badge badge-sm fs-16 ms-3 text-bg-" + (quotation.quotation_status === 'Won' ? 'success' : (quotation.quotation_status === 'Canceled' ? 'danger' : 'secondary'))}>{quotation.quotation_status}</span>
                      {quotation.quotation_status === 'Open' && (
                        <span className={"badge badge-sm fs-16 ms-3 text-bg-" + (quotation.quotation_approval === 'Approved' ? 'success' : (quotation.quotation_approval === 'Rejected' ? 'danger' : 'secondary'))}>{quotation.quotation_approval}</span>
                      )}
                    </div>
                    {quotation.quotation_status === 'Open' ? (
                      quotation.quotation_approval === 'Pending Approval' || quotation.quotation_approval === 'Pending Approval 1' || quotation.quotation_approval === 'Pending Approval 2' ? (
                        <div className="d-flex align-items-center justify-content-between gap-2">
                          <button className="btn btn-sm btn-danger" onClick={() => setApprovalStatus('Rejected')} disabled={isLoadingSubmit}><i className="bi bi-x-circle me-2"/> Reject</button>
                          <button className="btn btn-sm btn-success" onClick={() => setApprovalStatus('Approved')} disabled={isLoadingSubmit}><i className="bi bi-check-circle me-2"/> Approve</button>
                        </div>
                      ) : ''
                    ) : ''}
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Number</div>
                        <div className="col-md-8">{quotation.quotation_code}</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Company Group</div>
                        <div className="col-md-8">{quotation.company_name} <a href={`/client/detail/${quotation.company_id}`}><i className="bi bi-link-45deg"/></a></div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Subsidiary</div>
                        <div className="col-md-8">{quotation.subcompany_name} <a href={`/client/subsidiary/detail/${quotation.subcompany_id}`}><i className="bi bi-link-45deg"/></a></div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Currency</div>
                        <div className="col-md-8">{quotation.quotation_currency}</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Exchange Rate</div>
                        <div className="col-md-8">1 USD <i className="bi bi-arrow-right mx-1"/> {priceFormat(quotation.quotation_exchange_rate, quotation.quotation_currency)} ({quotation.quotation_exchange_floating})</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Created Date</div>
                        <div className="col-md-8">{format(quotation.initial_date, 'd MMMM yyyy')}</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Effective Date</div>
                        <div className="col-md-8">{format(quotation.created_on, 'd MMMM yyyy')}</div>
                      </div>
                      {quotation.quotation_status === 'Draft' || quotation.quotation_status === 'Open' ? (
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Expiry Date</div>
                          <div className="col-md-8">{format(quotation.quotation_expired_date, 'd MMMM yyyy')}</div>
                        </div>
                      ) : ''}
                      {quotation.quotation_item_list[0].product_active_licence_date && (
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Activation Date</div>
                          <div className="col-md-8">{format(quotation.quotation_item_list[0].product_active_licence_date, 'd MMMM yyyy')}</div>
                        </div>
                      )}
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Order Type</div>
                        <div className="col-md-8">{quotation.quotation_item_list[0].service_type}</div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-4 text-secondary">Sales Name</div>
                        <div className="col-md-8">{quotation.sales_name}</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
              {quotation && (
                <div className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">SKU List</div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th className="bg-primary text-light">#</th>
                          <th className="bg-primary text-light w-400">SKUs</th>
                          <th className="bg-primary text-light" style={{textAlign: 'center'}}>Period</th>
                          <th className="bg-primary text-light" style={{textAlign: 'center'}}>Qty</th>
                          <th className="bg-primary text-light" style={{textAlign: 'right'}}>Cost Price</th>
                          <th className="bg-primary text-light" style={{textAlign: 'right'}}>Unit Price</th>
                          <th className="bg-primary text-light" style={{textAlign: 'right'}}>Discount</th>
                          <th className="bg-primary text-light" style={{textAlign: 'right'}}>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {quotation.quotation_item_list && quotation.quotation_item_list.map((item, i) => (
                          <tr className={item.product_total === 0 ? 'd-none' : ''} key={i}>
                            <td>{i + 1}</td>
                            <td>
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <p className="mb-0"><strong>{item.product_display_name}</strong></p>
                              </div>
                              {item.product_display_description && item.product_display_description.split('\n').map((description, d) => (
                                <div className="row mb-1" key={"description-" + d}>
                                  {description.split(':').length > 1 ? (
                                    <div className="col-4">{description.split(':')[0].trim()}</div>
                                  ) : (
                                    <div className="col-12">{description.trim()}</div>
                                  )}
                                  {description.split(':').length > 1 && (
                                    <div className="col-8">
                                      <div className="d-flex">
                                        <span className="me-2">:</span>
                                        <div>{description.split(':').slice(1).join(':').trim()}</div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </td>
                            <td className="text-center">
                              {
                                item.product_type === 'Subscription' ? (
                                  (item.contract_long_period + " " + (item.contract_long_period > 1 ? ' Months' : ' Month'))
                                ) : 'N/A'
                              }
                            </td>
                            <td className="text-center">{item.product_qty + ' Unit(s)'}</td>
                            <td className="text-end">
                              {priceFormat(item.product_cost, item.product_currency)}
                              <br/>
                              {item.product_currency !== item.product_currency_original && (
                                <span className="text-secondary">{priceFormat(item.product_cost_original, item.product_currency_original)}</span>
                              )}
                            </td>
                            <td className="text-end">
                              {priceFormat(item.product_price, item.product_currency)}
                              <br/>
                              {item.product_currency !== item.product_currency_original && (
                                <span className="text-secondary">{priceFormat(item.product_price_original, item.product_currency_original)}</span>
                              )}
                            </td>
                            <td className="text-end">
                              {item.product_discount_price > 0 ? (
                                <span className="text-danger">-{priceFormat(item.product_discount_price, item.product_currency)}</span>
                              ) : 'N/A'}
                              <br/>
                              {item.product_discount_price > 0 && (
                                <span className="text-secondary">{item.product_discount_rate}%</span>
                              )}
                            </td>
                            <td className="text-end">
                              <span>{priceFormat(item.product_total, item.product_currency)}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td className="text-end" colSpan={7}>
                            Subtotal
                            <br/>
                            Discount {quotation.quotation_discount_price > 0 ? (" (" + priceFormat(quotation.quotation_discount_rate) + "%)") : ""}
                            <br/>
                            Total Before Tax
                          </td>
                          <td className="text-end">
                            {priceFormat(quotation.quotation_subtotal, quotation.quotation_currency)}
                            <br/>
                            {quotation.quotation_discount_price > 0 ? (<span className="text-danger">-{priceFormat(quotation.quotation_discount_price, quotation.quotation_currency)}</span>) : "0"}
                            <br/>
                            <strong>{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-end" colSpan={7}>
                            Total Cost
                            <br/>
                            Total Gross Margin {" (" + quotation.quotation_margin_rate + "%)"}
                          </td>
                          <td className="text-end">
                            {priceFormat(quotation.quotation_cost, quotation.quotation_currency)}
                            <br/>
                            {priceFormat(quotation.quotation_margin_price, quotation.quotation_currency)}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              )}

              {quotation && paymentSimulations && (
                <div className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">Payment Schedules</div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th className="bg-primary text-light">Schedule</th>
                          <th className="bg-primary text-light">Period</th>
                          <th className="bg-primary text-light">Date</th>
                          <th className="bg-primary text-light">SKUs</th>
                          <th className="bg-primary text-light w-150" style={{textAlign: 'right'}}>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {quotation.quotation_items && (
                          (() => {
                            const termGroups = {};
                            quotation.quotation_items.forEach((item) => {
                              item.payment_simulations.forEach((payment) => {
                                const key = `${payment.term_number}-${payment.number_of_months}`;
                                if (!termGroups[key]) {
                                  termGroups[key] = {
                                    term_number: payment.term_number,
                                    number_of_months: payment.number_of_months,
                                    start_term_period: payment.start_term_period,
                                    end_term_period: payment.end_term_period,
                                    items: [],
                                  };
                                }
                                termGroups[key].items.push({
                                  product_display_name: item.product_display_name,
                                  payment_amount_exc_tax: payment.payment_amount_exc_tax,
                                });
                              });
                            });
      
                            const sortedTerms = Object.values(termGroups).sort((a, b) => a.term_number - b.term_number);
      
                            return sortedTerms.map((term, termIndex) => {
                              const rowspan = term.items.length;
                              return term.items.map((item, itemIndex) => (
                                <tr key={`term-${termIndex}-item-${itemIndex}`}>
                                  {itemIndex === 0 && (
                                    <>
                                      <td rowSpan={rowspan} valign="middle">
                                        {term.term_number.replace('Term', 'Schedule')}
                                      </td>
                                      <td rowSpan={rowspan} valign="middle">
                                        {term.number_of_months + (term.number_of_months > 1 ? ' Months' : ' Month')}
                                      </td>
                                      <td rowSpan={rowspan} valign="middle">
                                        {format(new Date(term.start_term_period), 'dd MMM yyyy') !== format(new Date(term.end_term_period), 'dd MMM yyyy') ? (
                                          <span>
                                            {(format(new Date(term.start_term_period), 'dd MMM yyyy')) + " - " + (format(new Date(term.end_term_period), 'dd MMM yyyy'))}
                                          </span>
                                        ) : (
                                          <span>{format(new Date(term.start_term_period), 'dd MMM yyyy')}</span>
                                        )}
                                      </td>
                                    </>
                                  )}
                                  <td>{item.product_display_name}</td>
                                  <td style={{ textAlign: 'right' }}>
                                    {priceFormat(item.payment_amount_exc_tax, quotation.quotation_currency)}
                                  </td>
                                </tr>
                              ));
                            }).flat();
                          })()
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td className="text-end" colSpan={4}>Total Before Tax</td>
                          <td className="text-end">
                            <strong>{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              )}

              {quotation && (
                <div className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">Attachments</div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row align-items-top form-group mb-2">
                        <div className="col-md-2">
                          <label>Files</label>
                        </div>
                        <div className="col-md-10">
                          {JSON.parse(quotation.attachment_files) && (
                            <div className="table-responsive">
                              <table className="table table-bordered mb-2">
                                <thead>
                                  <tr>
                                    <th className="bg-secondary text-light" style={{textAlign: 'center'}}>#</th>
                                    <th className="bg-secondary text-light w-400">Name</th>
                                    <th className="bg-secondary text-light">File</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {JSON.parse(quotation.attachment_files).map((attachments, a) => 
                                    <tr key={"attachment-" + a}>
                                      <td valign="middle" align="center">{a + 1}</td>
                                      <td valign="middle">{attachments.name}</td>
                                      <td valign="middle">
                                        {Array.isArray(attachments.files) && attachments.files.length > 0 && (
                                          <a className="ellipsis" href={attachments.files[0].fileUrl} target="_blank" rel="noopener noreferrer">{shortenUrl(attachments.files[0].fileUrl, 50)} <i className="bi bi-link-45deg ms-2"/></a>
                                        )}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="row align-items-baseline form-group mb-2">
                        <div className="col-md-2">
                          <label>Quotation Remarks</label>
                        </div>
                        <div className="col-md-10">{quotation.quotation_remarks}</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>

        <Modal show={showApproval} onHide={() => setShowApproval(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Reject Quotation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row align-items-baseline form-group mb-2">
              <div className="col-md-4">
                <label>Remarks <span className="text-danger">*</span></label>
              </div>
              <div className="col-md-8">                
                <textarea className="form-control" rows="4" value={approvalRemarks} onChange={(e) => setApprovalRemarks(e.target.value)} required/>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn btn-link" type="button" onClick={() => setShowApproval(false)}>Cancel</button>
              <button className="btn btn-danger" type="button" onClick={() => editStatus()}>Reject</button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default QuotationApproval;


